const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');
const runtimeOrigin =
  typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3005';
const defaultMainServiceURL = 'https://mbes.promptlab.vernalabs.net';

const resolveMainServiceURL = () => {
  if (typeof window === 'undefined') {
    return defaultMainServiceURL;
  }

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return runtimeOrigin;
  }

  return defaultMainServiceURL;
};

// Main-service URL — all frontend traffic is routed through this
export const mainServiceURL = trimTrailingSlashes(
  import.meta.env.VITE_MAIN_SERVICE_URL || resolveMainServiceURL()
);

// Auth: goes directly to main-service (same as ghostnews/weelia pattern)
// e.g. mbes.promptlab.vernalabs.net/v1/promptlab/auth/login
export const authServiceURL = `${mainServiceURL}/v1/promptlab`;

// Registry: all calls go through main-service gateway → internal registry
// Gateway forwards: mbes.promptlab.vernalabs.net/v1/promptlab/gateway/promptlab-registry-service/{endpoint}
//   → http://registry.internal.vernalabs.net/v1/{endpoint}
export const registryServiceURL = `${mainServiceURL}/v1/promptlab/gateway/promptlab-registry-service`;
export const registryApiPathPrefix = '';

// Router: goes through registry's RouterGatewayModule at /v1/router/...
// Path: .../promptlab-registry-service/router/{endpoint}
//   → http://registry.internal.vernalabs.net/v1/router/{endpoint}
const configuredRouterServiceURL = trimTrailingSlashes(
  import.meta.env.VITE_ROUTER_SERVICE_URL || `${registryServiceURL}/router`,
);
const routerUrl = new URL(configuredRouterServiceURL, runtimeOrigin);
const routerPathname = trimTrailingSlashes(routerUrl.pathname);
const routerUsesRegistryGateway = routerPathname.includes('/gateway/promptlab-registry-service');

// routerServiceURL is the base for RTK Query (without the /router suffix)
// routerApiPathPrefix is /router (not /v1/router — the gateway URL already carries /v1 via settings DB)
export const routerServiceURL = routerUsesRegistryGateway
  ? configuredRouterServiceURL.replace(/\/router$/, '')
  : configuredRouterServiceURL;

export const routerApiPathPrefix = routerUsesRegistryGateway ? '/router' : '/v1';
